import axios from "axios";
import axiosRetry from "axios-retry";
import { getCookie } from "../lib/utils/cookieUtil";
class ApiClass {
  constructor() {
    this.axiosInstance = axios.create({
      baseURL: process.env.REACT_APP_BUILD_DOMAIN,
      timeout: 10000, // Add a default timeout
      headers: {
        "Content-Type": "application/json",
      },
    });

    axiosRetry(this.axiosInstance, {
      retries: 3,
      retryDelay: retryCount => retryCount * 1000,
      retryCondition: error => error.response?.status === 504,
    });
    this.axiosInstance.interceptors.request.use(
      config => {
        // Get the token from wherever you store it (e.g., localStorage)
        const token = getCookie("session_id");
        const sessionToken = `_enlighten_4_session=${token}`;

        // If the token exists, add it to the Authorization header
        if (token) {
          config.headers["Authorization"] = `${sessionToken}`;
          config.headers["e-auth-token"] = `${token}`;
        }

        return config; // The request will continue with the updated headers
      },
      error => {
        // Handle request errors
        return Promise.reject(error);
      }
    );
  }

  async _request(method, url, data = {}, config = {}) {
    /* eslint-disable  no-unused-vars*/
    const { params, body, ...axiosConfig } = config;

    const requestConfig = {
      method,
      url,
      ...axiosConfig,
      headers: { ...this.axiosInstance.defaults.headers, ...axiosConfig.headers },
    };

    if (method.toLowerCase() === "get" || method.toLowerCase() === "delete") {
      requestConfig.params = data;
    } else {
      requestConfig.data = data;
    }

    try {
      const response = await this.axiosInstance(requestConfig);
      return response.data;
    } catch (error) {
      console.error("_request ~ error:", error);
      throw error;
    }
  }

  get(url, params = {}, config = {}) {
    return this._request("get", url, params, config);
  }

  post(url, body = {}, config = {}) {
    return this._request("post", url, body, config);
  }

  patch(url, body = {}, config = {}) {
    return this._request("patch", url, body, config);
  }

  delete(url, params = {}, config = {}) {
    return this._request("delete", url, params, config);
  }

  upload(url, formData, onUploadProgress) {
    return this._request("post", url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress,
    });
  }
}

const Api = new ApiClass();
export default Api;
